import { useSyncExternalStore } from "react";
import { ReadonlyObservableProperty } from "./wrapper/ObservableProperty";

export function useSyncCesium<T>(property: ReadonlyObservableProperty<T>) {
  return useSyncExternalStore(property.subscribe, property.getSnapshot);
}
